/**
 * Provider pour NextAuth.js
 * 
 * Enveloppe l'application avec SessionProvider pour permettre
 * l'utilisation de useSession() dans les composants.
 * 
 * Note: Ce provider est nécessaire pour utiliser le service NextAuth Drupal.
 * Le SessionProvider peut fonctionner même si NextAuth n'est pas complètement configuré,
 * il retournera simplement une session null.
 */

"use client"

import { SessionProvider } from "next-auth/react"

interface NextAuthProviderProps {
  children: React.ReactNode
}

export function NextAuthProvider({ children }: NextAuthProviderProps) {
  // Toujours rendre le SessionProvider avec le basePath correct
  // Cela évite l'erreur "useSession must be wrapped in a <SessionProvider />"
  // et s'assure que les requêtes vont vers la bonne route API
  return (
    <SessionProvider basePath="/api/auth/nextauth-drupal">
      {children}
    </SessionProvider>
  )
}

